export class PackagingLabelItem {
  public description: string;
  public number: number;
  constructor() {
  }
}
